import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { ScrollToTop } from './components/scrollToTop/ScrollToTop'
import { AuthProvider } from './contexts/AuthContext'
import { ConfigProvider } from './contexts/ConfigContext'
import { ConfirmProvider } from './contexts/ConfirmContext'
import { ProfileProvider } from './contexts/ProfileContext'

//@ts-ignore
import './index.scss'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
//@ts-ignore
import './i18n'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <AuthProvider>
      <ProfileProvider>
        <ConfirmProvider>
          <ConfigProvider>
            <App />
          </ConfigProvider>
        </ConfirmProvider>
      </ProfileProvider>
    </AuthProvider>
  </BrowserRouter>
)
